import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import Spinner from '../../components/Spinner';
import styles from './styles.module.scss';

const Step16View = ({email}) => {
  return (
    <div className={styles.formContainer}>
      <div className={styles.successTitle}>
        <FormattedMessage
          id={'step16.successTitle'}
          defaultMessage={'Cheers! We have completed the registration process'}
        />
      </div>
      <div className={styles.text}>
        <FormattedMessage
          id={'step16.mail.text.1'}
          defaultMessage={'Our representatives will review all forms as soon as possible'}
        />
      </div>
      <div className={styles.text}>
        <FormattedMessage
          id={'step16.mail.text.2'}
          defaultMessage={'Final confirmation will be emailed to:'}
        />
      </div>
      <div className={styles.spinnerContainer}>
        <Spinner/>
      </div>
      <div className={styles.text}>
        <FormattedMessage
          id={'step16.mail.text.3'}
        />
      </div>
      <div className={`${styles.successTitle} ${styles.email}`}>
        {email}
      </div>
      <div className={styles.text}>
        <FormattedMessage
          id={'step16.regards.text.1'}
          defaultMessage={'Regards,'}
        />
      </div>
      <div className={styles.text}>
        <FormattedMessage
          id={'step16.regards.text.2'}
          defaultMessage={'Self-employed'}
        />
      </div>
    </div>
  )
};

Step16View.propTypes = {
  email: PropTypes.string,
};

export default Step16View;
